<template>
  <div :class="{content: true,empty: list && list.length === 0}">
    <div class="filters">
      <div class="cates new">
        <div class="cate" v-for="(f, i) in filters" :key="i">
          <span class="name" v-if="f.key=='type_id'">类型</span>
          <span class="name" v-else>{{f.title}}</span>
          <p :class="{btn: true, on: c.selected}" v-for="(c, d) in f.list" :key="d" @click="selectFilter(c, f)">
            {{c.title}}
          </p>
        </div>
      </div>
      <div class="pie">
        <div class="chart">
          <div :class="{rightHalf: pie.position === 'left', leftHalf: pie.position === 'right'}"></div>
          <div :class="{spinner: true, down: pie.position === 'right', up: pie.position === 'up'}" :style="{transformOrigin: '100% 50%', transform: `rotate(${pie.deg}deg)`}"></div>
        </div>
        <p class="detail">
          {{`使用量：${borrow.use}/${borrow.total}`}}
        </p>
      </div>
    </div>
    <div class="list">
      <div class="handles">
        <div class="left">
          <div class="btn" @click="handleChecks(-1)">
            <img src="@assets/img/resources/del.svg" alt="delete">
            <span class="name">删除</span>
          </div>
          <div class="btn" @click="handleChecks(1)">
            <img src="@assets/img/resources/on.svg" alt="delete">
            <span class="name">启用</span>
          </div>
          <div class="btn" @click="handleChecks(0)">
            <img src="@assets/img/resources/off.svg" alt="delete">
            <span class="name">停用</span>
          </div>
        </div>
        <div class="btn greenBtn" @click="openAdd(2)">
          <img src="@assets/img/resources/add.svg" alt="add">
          <span class="name">添加</span>
        </div>
      </div>
      <div class="headline">
        <img :src="allChecked ? icons.checkerOn : icons.checker" alt="checker" class="checker" @click="checkAll()">
        <span class="number">设备编号</span>
        <span class="name">名称</span>
        <span class="cate">分类</span>
        <span class="type">类型</span>
        <span class="status">状态</span>
        <span class="borrower">待执行</span>
        <span class="handle">操作</span>
      </div>
      <empty :mTop="30" :msg="'暂无设备数据'" v-if="list && list.length === 0" />
      <div v-for="(l, i) in list" :key="i">
        <div :class="{content: true, red: l.status == 0, yellow: l.status == 2}">
          <div class="item">
            <img :src="l.checked ? icons.checkerOn :icons.checker" alt="checker" class="checker" @click="checkItem(l)">
            <span class="theme" @click="goDetail(l.device_id)">
              <p class="words" :title="l.idstring">
                {{l.idstring}}
              </p>
              <span class="msgIcon" v-if="l.msg">
                <img src="@assets/img/interview/msg.svg" alt="msg">
                <p class="msgContent">
                  {{l.msg}}
                </p>
              </span>
              <img src="@assets/img/interview/alert.svg" alt="warn" v-if="i.warn">
            </span>
            <span class="name">{{l.title}}</span>
            <span class="cate">{{l.class_title}}</span>
            <span class="type">{{l.type_title}}</span>
            <span class="status">{{l.status_name}}</span>
            <span class="borrower" @click="toggleExpand(l)">
              <span>{{l.task_num}}</span>
              <img :src="l.expand ? icons.up : icons.down" alt="icon" class="icon">
            </span>
            <span class="handle">
              <span v-if="l.status == 0" class="btn" @click="startUse(l)">
                启用
              </span>
              <span v-else class="btn" @click="stopUse(l)">
                停用
              </span>
            </span>
          </div>
        </div>
        <div class="childContent" v-if="l.expand">
          <div class="childItem" v-for="(c, ci) in l.todos" :key="ci + 1">
            <div class="theme" @click="goTypeDetail(c)">
              <span class="tag">{{c.type_name}}</span>
              <p class="words" @click="goTask(c)">
                {{c.title}}
              </p>
            </div>
            <div class="cate">
              {{c.name}}
            </div>
            <div class="type">
              {{c.status_name}}
            </div>
            <div class="status">
              <span>{{c.start}}</span>
              <span>{{c.end}}</span>
            </div>
            <div class="borrower"></div>
            <div class="handle">
              <span v-if="c.status - 0 === 1" class="btn" @click="cancelTask(c.task_id)">取消</span>
              <span v-if="c.status - 0 === 2" class="btn" @click="finishTask(c.task_id)">结束</span>
            </div>
          </div>
          <div class="loan">
            <div class="btn" @click="openLoan(l)">
              <img src="@assets/img/resources/add.svg" alt="add">
              <span>外借</span>
            </div>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
    <addResource ref="addResource" />
    <equipmentLoan ref="equipmentLoan" />
    <stopUse ref="stopUse" />
  </div>
</template>

<script>
import pages from '@components/pages'
import addResource from '@components/addResource'
import common from '@common/common'
import {apis} from '@common/config'
import equipmentLoan from '@components/equipmentLoan'
import stopUse from '@components/stopUse'
import empty from '@components/empty'

export default {
  name: 'equipments',
  components: {
    pages, addResource, equipmentLoan, stopUse, empty
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      icons: {
        checker: require('@assets/img/interview/checker.svg'),
        checkerOn: require('@assets/img/interview/checkerOn.svg'),
        up: require('@assets/img/topics/up.svg'),
        down: require('@assets/img/topics/down.svg')
      },
      filters: [],
      list: null,
      allChecked: false,
      filterOptions: {},
      filterType: null,
      borrow: {
        use: 0,
        total: 0
      },
      pie: {
        position: 'left',
        deg: 0
      }
    }
  },
  methods: {
    goTask(c) {
      if (c.relate_type != 0) return

      this.$router.push({
        path: '/interviewDetail',
        query: {
          r: c.relate_id
        }
      })
    },
    goTypeDetail(i) {
      // 去关联内容详情页
      console.log(1234, i)
    },
    getList() {
      // 获取设备列表
      const id = this.$route.params.id
      const info = {
        idstring: id,
        class_id: '',
        type_id: '',
        status: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      // this.searchOptions.key_words = this.$store.state.keyWord

      Object.assign(info, this.filterOptions)

      common.myFetch(apis.Res_devicelist, info)
      .then((data) => {
        this.list = data.list
        this.filters = data.params.list_search
        this.borrow = {
          use: data.use_num - 0,
          total: data.total_num - 0
        }
        this.calculatePie()
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.page.row_count - 0)
      })
    },
    calculatePie() {
      // 计算并绘制饼图
      const u = this.borrow.use        // 借出数
      const t = this.borrow.total      // 总数
      const r = (u/t)*100              // 系数
      // 默认（度数为0）时，遮罩（绿色）位于左侧，转头位于左侧（置于下方）
      if(r >= 50) {                    // 系数大于等50，转头置于上方，由180 - 360度旋转；遮罩（白色）位于右侧
        this.pie.position = 'left'
      } else {                         // 系数小于50，转头置于下方，由0 - 180度旋转；遮罩（绿色）位于左侧
        this.pie.position = 'right'
      }

      this.pie.deg = r * 3.6
    },
    getTasks(id, item) {
      // 获取设备相关任务
      const info = {
        device_id: id
      }

      return common.myFetch(apis.Res_device_tasks, info)
      .then((data) => {
        this.$set(item, 'todos', data.list)
      })
    },
    handleChecks(status) {
      // 删除／启用／停用 所选设备
      const ids = []
      this.list.forEach((d) => {
        if (d.checked) {
          ids.push(d.device_id)
        }
      })
      if (ids.length <= 0) {
        this.$toast('请选择设备')
        return
      }

      const idString = ids.join(',')
      this.useDevice(idString, status)
    },
    useDevice(id, status) {
      // 设备操作接口
      const info = {
        device_id: id,
        status: status // -1:删除，0:停用，1启用
      }

      common.myFetch(apis.Res_device_use, info)
      .then((data)=>{
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    },
    cancelTask(id) {
      // 取消设备任务
      const info = {
        task_id: id
      }
      common.myFetch(apis.Res_device_task_cancel, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
        }
      })
    },
    finishTask(id) {
      // 完成设备任务
      this.$refs.stopUse.open(id)
    },
    selectFilter(i, f) {
      // 选择筛选条件
      if (i.selected) return

      this.page.pageIndex = 1

      f.list.forEach((s) => {
        s.selected = false
      })

      this.$set(i, 'selected', true)
      if (i.class) {
        this.filterType = i.class
      }
      this.filterOptions[f.key] = i.key
      this.$nextTick(() => {
        this.getList()
      })
    },
    toggleExpand(l) {
      // 展开／关闭 设备任务列表
      if (!l.expand) {
        this.getTasks(l.device_id, l)
      }

      this.$set(l, 'expand', !l.expand)
    },
    goDetail(d) {
      // 跳转设备详情
      // this.$router.push({
      //   path: '/equipmentDetail',
      //   query: {
      //     d: d
      //   }
      // })

      common.jump(`/equipmentDetail?d=${d}`, true)
    },
    checkAll() {
      // 选择所有设备
      const status = !this.allChecked

      this.list.forEach((i) => {
        this.$set(i, 'checked', status)
      })
      this.allChecked = status
    },
    checkItem(i) {
      // 单选设备
      this.$set(i, 'checked', !i.checked)

      this.$nextTick(() => {
        if (!i.checked) {
          this.allChecked = false
        }
      })
    },
    openAdd(t) {
      // 添加设备弹窗
      this.$refs.addResource.open(t)
    },
    openLoan(l) {
      // 设备外借弹窗
      this.$refs.equipmentLoan.open({id: l.device_id, title: l.title, string: l.idstring})
    },
    async stopUse(l) {
      // 设备停用弹窗
      const c = await this.$confirm('确认停用吗？')
      if (!c) return

      this.useDevice(l.device_id, 0)
    },
    async startUse(l) {
      // 设备启用弹窗
      const c = await this.$confirm('确认启用吗？')
      if (!c) return

      this.useDevice(l.device_id, 1)
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="less" src="@assets/css/resource/equipments.less" scoped></style>
